// extracted by mini-css-extract-plugin
module.exports = {"pagination":"ShiftMaster_pagination_2AYVQ","paginationText":"ShiftMaster_paginationText_37ie8","paginationButton":"ShiftMaster_paginationButton_3ter3"};